/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {constants} from "@well/infra/constants";

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  public getCurrencySelectItems(): SelectItem[] {
    return constants.currencyList;
  }

  public getCurrencyItemsMap(): Map<string, string> {
    return new Map<string, string>(
      this.getCurrencySelectItems().map(item => [item.value, item.label] as [string, string])
    );
  }
}
